import firebase from 'firebase/app'
import 'firebase/firestore'
const db = firebase.firestore()

const state = {
  chat: null,
  chats: [],
  messages: []
}

const actions = {
  GET_CHAT ({ commit }, chatId) {
    return new Promise((resolve, reject) => {
      db.collection('chatGroups').doc(chatId).get()
        .then((doc) => {
          if (doc.exists) {
            const chatData = doc.data()
            // Add the id field to the chatData object
            chatData.id = doc.id
            resolve(chatData)
            commit('SET_LOADED_CHAT', chatData)
          } else {
            reject(new Error('No such chat group!'))
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  GET_ALL_CHATS ({ commit }) {
    return new Promise((resolve, reject) => {
      let ref = db.collection('chatGroups')
      let unsub = ref.onSnapshot(snapshot => {
        let chats = []
        snapshot.forEach((doc) => {
          let log = {
            'id': doc.id,
            ...doc.data()
          }
          chats.push(log)
        })
        commit('SET_LOADED_CHATS', chats)
        resolve(unsub)
      }, (error) => {
        reject(error)
      })
    })
  },
  GET_MESSAGES ({ commit }, chatId) {
    return new Promise((resolve, reject) => {
      let ref = db.collection('messages')
        .where('chatGroupId', '==', chatId)
        .orderBy('timestamp', 'desc') // Order by the timestamp in descending order
        .limit(100) // Only fetch the 10 most recent messages
      let unsub = ref.onSnapshot(snapshot => {
        let messages = []
        snapshot.forEach((doc) => {
          let log = {
            'id': doc.id,
            ...doc.data()
          }
          messages.push(log)
        })
        commit('SET_LOADED_MESSAGES', messages)
        resolve(unsub)
      }, (error) => {
        reject(error)
      })
    })
  },
  SEND_MESSAGE ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      db.collection('messages').add(payload)
        .then((docRef) => {
          resolve(docRef)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  DELETE_MESSAGE ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      db.collection('messages').doc(payload).delete()
        .then(() => {
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  LIKE_MESSAGE ({ commit }, messageId) {
    return new Promise((resolve, reject) => {
      const messageRef = db.collection('messages').doc(messageId)

      // Get the current likes array
      messageRef.get()
        .then((doc) => {
          if (doc.exists) {
            const { likes } = doc.data()
            const userId = firebase.auth().currentUser.uid

            // Toggle the like status for the user
            if (likes && likes.includes(userId)) {
              // Unlike the message
              const index = likes.indexOf(userId)
              if (index !== -1) {
                likes.splice(index, 1)
              }
            } else {
              // Like the message
              likes.push(userId)
            }

            // Update the likes array in the message document
            messageRef.update({ likes })
              .then(() => {
                resolve()
              })
              .catch((error) => {
                reject(error)
              })
          } else {
            reject(new Error('No such message!'))
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  GET_MESSAGES_COUNT_BY_USER ({ commit }, userId) {
    return new Promise((resolve, reject) => {
      db.collection('messages')
        .where('senderId', '==', userId)
        .get()
        .then((querySnapshot) => {
          resolve(querySnapshot.size)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}

const getters = {
}

const mutations = {
  SET_LOADED_CHAT (state, payload) {
    state.chat = payload
  },
  SET_LOADED_CHATS (state, payload) {
    state.chats = payload
  },
  SET_LOADED_MESSAGES (state, payload) {
    state.messages = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
